module.exports = __webpack_public_path__ + "static/media/30-2.7aea9128.mp3";